export const CONTAINER = 'container';
export const STANDARD = 'standard';
export const FULLSCREEN = 'fullscreen';
export const PLAYER_ZONE = 'player';
export const TEXT = 'text';
export const BUTTON = 'button';
export const IMAGE = 'image';
export const ICON = 'icon';
export const FORM = 'form';
export const FAVORITE_BUTTON = 'favoriteButton';
export const MINI_PLAYER = 'miniPlayer';
export const CHARTS = {
  GAUGE: 'chart:gauge',
};

export const QUIZ_OPTION = 'quizOption';
export const CLOSE_BUTTON = 'closeButton';
export const AUTO_CLOSE = 'autoClose';
export const AUTO_CLICK = 'autoClick';

export const POLL = 'poll';
export const POLL_KEY = 'pollId';
export const POLL_OPTION = 'pollOption';
export const POLL_CHART = 'chart';
export const POLL_RESULT = 'pollResult';
export const QUIZ_RESULT = 'quizResult';
export const POLL_STATE = 'pollState';
export const POLL_STATE_VOTE = 'vote';
export const POLL_STATE_RESULT = 'result';

export const SCROLL_CONTAINER = 'scrollContainer';
export const NUMBER_PICKER = 'numberPicker';
export const SLIDER = 'slider';
